<template>
<div class="filenames">
  FILENAMES - {{gameName.game}}
  <div>
    <li v-for="filename in overlayData">
      {{filename.name}}: ${{filename.amount}}
    </li>
  </div>
</div>
</template>

<script>
  import axios from 'axios'

  export default {
    mounted() {
      this.loadData()
    },
    data () {
      return {
        gameName: [],
        overlayData: []
      }
    },
    methods: {
      loadData () {
        axios.get(`/api/overlay/display`).then(({ data }) => {
          this.overlayData = data.overlay.filenames
          this.gameName = this.overlayData
          this.overlayData = this.overlayData.names
        })
      }
    }
  }
</script>

<style scoped>
.filenames {
  position:fixed;
  background-color:blue;
  color:white;
  height:37vh;
  width:35vw;
  top:60vh;
  left:0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Filenames.vue